import { CanActivateFn } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { ConfigService } from '@fcom/core/services';
import { LanguageService } from '@fcom/ui-translate/services/language.service';
import { RootPaths } from '@fcom/core/constants';
import { WindowRef } from '@fcom/core/providers';

export const changePasswordGuard: CanActivateFn = () => {
  const windowRef = inject(WindowRef);
  const configService = inject(ConfigService);
  const languageService = inject(LanguageService);
  const platform = inject(PLATFORM_ID);

  if (isPlatformServer(platform)) {
    return true;
  }
  const returnUrl = `${configService.cfg.baseUrl}/${languageService.langValue}/${RootPaths.CORPORATE}/home`;
  windowRef.nativeWindow.location.href = `https://${configService.cfg.casHost}/content/${languageService.localeValue}/change-password/?returnUrl=${returnUrl}`;
  return true;
};
